export interface StockMatch {
  stockId: string;
  stockName: string;
  stockUnit?: string;
  vendorId?: string;
  vendorName?: string;
  companyId?: string;
  companyName?: string;
  similarityScore: number;
}

export interface StockReviewRequest {
  reviewId: string;
  extractedStockName: string;
  stockUnit?: string;
  vendorId?: string;
  fileName?: string;
  orchestrationInstanceId?: string;
  batchId?: string;
  currentPage?: number;
  totalItems?: number;
  pageSize?: number;
}

export enum StockReviewDecisionType {
  MapExisting = 'MapExisting',
  CreateNew = 'CreateNew',
}

export enum StockReviewStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

export interface StockReviewDecision {
  ReviewId: string;
  Decision: StockReviewDecisionType;
  SelectedStockId?: string;
  NewStockName?: string;
}

export interface BatchStockReviewRequest {
  BatchId: string;
  OrchestrationInstanceId: string;
  StockReviews: StockReviewRequest[];
}

// Stock review with matching stocks included (from API response)
export interface StockReviewWithMatches extends StockReviewRequest {
  matchingStocks: StockMatch[];
}
